module.exports = __webpack_public_path__ + "img/6.9a57b0dc.png";